<template>
  <v-container
    id="widgets"
    fluid
    tag="section">
    <base-material-card class="px-5 py-3">
      <template v-slot:heading>
        <div class="headline mt-3 font-weight-light">
         Relatório de serviços atendido
        </div>
      </template>
      <v-form id="appTable">
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          min-width="290px"
          offset-y>
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="datestring"
              color="secondary"
              prepend-icon="mdi-calendar-outline"
              readonly
              v-on="on"/>
          </template>
          <v-date-picker
            v-model="date"
            color="secondary"
            no-title
            scrollable
            type="month"
            @input="menu1 = false"/>
        </v-menu>
        <template v-for="(item, i) in items">        
          <v-container style="padding: 0" :key="item.id">
            <div style="position: relative; top: -20px; float: right;">                
                <v-text-field class="title" v-text="item.empresa" />
            </div>          
            <v-row no-gutters>
              <v-col :cols=undefined>
                    <v-text-field class="display-2" v-text="item.dataInicio" />
                    <v-text-field style="padding-left: 8px;" v-text="item.duracao" />
              </v-col>
              <v-col :cols=9>
                    <v-text-field v-text="item.cliente" />
                    <small  v-text="item.servico" />                  
                    <div style="padding: 0">
                    <small class="quote" v-text="item.descricao" />                                        
                    </div>
              </v-col>
            </v-row>
          </v-container>         
          <v-divider
              v-if="i + 1 < items.length"
              :key="i"/> 
        </template>
      </v-form>
    </base-material-card>
  </v-container>
</template>
<script>

  function gettanggal (str) {
    if (str != null) {
      return str.substring(5, 7) + '/' + str.substring(0, 4)
    }
    return ''
  }
  function getDateJson (str) {
    if (str != null) {
      return str.substring(0, 4) + '-' + str.substring(5, 7) + '-01'
    }
    return ''
  }

  export default {
    name: 'Widgets',
    components: {

    },
    data: () => ({
      date: new Date().toISOString().substr(0, 7),
      menu1: false,
      dark: true,
      datestring: gettanggal(new Date().toISOString().substr(0, 7)),
      dateJson: getDateJson(new Date().toISOString().substr(0, 7)),
      items: [
   /*      {
          id: '1',
          empresa: 'w3g1',
          dataInicio: '10:00',
          duracao: '60',
          cliente: 'Maria Joana',
          servico: 'Limpeza de dente',
          descricao: 'cliente tem alergia a agua e come muito asd ad sdf asd' ,
        },
        {
          id: '2',
          empresa: 'w3g1',
          dataInicio: '10:00',
          duracao: '60',
          cliente: 'Maria Joana',
          servico: 'Limpeza de dente',
          descricao: 'cliente tem alergia a agua e come muito asdf asdf asdf asd fasd',
        },         */
      ],
    }),
    watch: {
      date: function (val, oldVal) {
        this.datestring = gettanggal(val)
        this.dateJson = getDateJson(val)
        this.doConsultaAgenda()
      },
    },
    mounted () {
      this.doConsultaAgenda()
    },    
    methods: {     
      doConsultaAgenda () {
      /*   if (localStorage.chaveFuncionarioMobile) {
          var funcionarioMobile = {
            'chave': localStorage.chaveFuncionarioMobile,
          }
          try {
            if (funcionarioMobile.chave) {
              this.$http.post('/ProjetoX/rest/externo/funcionario/mobile/compromissos/' + this.dateJson, funcionarioMobile)
                .then(resposta => {
                  this.items = resposta.data
                })
            }
          } catch (error) {
            alert('Erro ao listar agenda.')
            console.log(error)
          }
        } */
      },      
    },
  }
</script>
